import type { PropertyFormValues } from '@/lib/types/property';
import type { PropertyEditFormState } from './types';

export const BOOLEAN_KEYS = new Set<keyof PropertyEditFormState>();

export function createInitialState(property: PropertyFormValues): PropertyEditFormState {
  return {
    propertyCode: property.propertyCode,
    submarket: property.submarket,
    assetType: property.assetType,
    totalRentableSf: String(property.totalRentableSf),
    marketingSummary: property.marketingSummary,
    streetNumber: property.address.streetNumber,
    streetName: property.address.streetName,
    streetType: property.address.streetType,
    streetDirection: property.address.streetDirection ?? '',
    suiteNumber: property.address.suiteNumber ?? '',
    city: property.address.city,
    province: property.address.province,
    postalCode: property.address.postalCode,
    heroMediaUrls: property.heroMediaUrls,
  };
}

export function buildPropertyEditPayload({
  property,
  formState,
}: {
  property: PropertyFormValues;
  formState: PropertyEditFormState;
}): PropertyFormValues {
  const trimmedHeroUrls = formState.heroMediaUrls
    .map((url) => url.trim())
    .filter((url) => url.length > 0);

  return {
    ...property,
    propertyCode: formState.propertyCode.trim(),
    submarket: formState.submarket.trim(),
    assetType: formState.assetType,
    totalRentableSf: Number(formState.totalRentableSf) || 0,
    marketingSummary: formState.marketingSummary.trim(),
    heroMediaUrls: trimmedHeroUrls,
    address: {
      streetNumber: formState.streetNumber.trim(),
      streetName: formState.streetName.trim(),
      streetType: formState.streetType,
      streetDirection: formState.streetDirection === '' ? null : formState.streetDirection,
      suiteNumber: formState.suiteNumber.trim() || null,
      city: formState.city.trim(),
      province: formState.province,
      postalCode: formState.postalCode.trim(),
    },
  };
}
